import React from 'react';
import { Button } from '@roger/ui-components';
import { useNavigate } from 'react-router-dom';
import { useBreadcrumbs } from '../components/breadcrumbs/BreadcrumbContext';
import Stedi_270_Testing from '../components/Stedi_270_Testing';

const TestingStedi_270: React.FC = () => {
  const navigate = useNavigate();
  useBreadcrumbs([{ label: 'Stedi 270' }]);

  return (
    <div className='space-y-6'>
      <div className='flex items-center justify-between'>
        <div className='flex items-center space-x-4'>
          <Button
            variant='outline'
            onClick={() => navigate('/testing')}
            className='flex items-center space-x-2'
          >
            <span>←</span>
            <span>Back to Testing</span>
          </Button>
        </div>
      </div>

      <Stedi_270_Testing />
    </div>
  );
};

export default TestingStedi_270;
